module.exports = __webpack_public_path__ + "media/images/slide1-7ccc38dd27f35d36e7bd192cfa164cb9.webp";